import Vue from 'vue'
import './plugin/vee-validate';

document.addEventListener('DOMContentLoaded', () => {
  var app = new Vue({
    el: '#auth',
    data: {
      email: '',
      password: '',
      passwordConfirmation: '',
      currentPassword: '',
      agreement: false,
    },
    methods: {
      async submit(e) {
        e.preventDefault();
        const btn = document.getElementById("auth-submit");
        btn.disabled = true;
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          document.getElementById('auth-form').submit();
        } else {
          btn.disabled = false;
        }
      }
    }
  })
});